import { __assign, __extends, __rest } from "tslib";
import { namespacedClassnames } from '../../common';
import * as React from 'react';
import { KeyCode } from '../../common/key-codes.enum';
import * as ReactDOM from 'react-dom';
import { deprecatedMsg } from '@wix/answers-lib';
import { calculateInputSelection } from '../../common/user-input-commons';
import { Tooltip } from '../tooltip/tooltip';
var defaultProps = {
    disabled: false
};
export var deprecatedInputKey = 'deprecated-input';
/** @deprecated please use \<TextInput/> */
var DeprecatedInput = /** @class */ (function (_super) {
    __extends(DeprecatedInput, _super);
    function DeprecatedInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = null;
        _this.setInputRef = function (ref) { return _this.inputRef = ref; };
        _this.focus = function () {
            if (_this.inputRef) {
                var input = ReactDOM.findDOMNode(_this.inputRef);
                input.focus();
            }
        };
        _this.onChange = function (e) {
            _this.props.onChange(e.target.value);
        };
        _this.onKeyDown = function (e) {
            var props = _this.props;
            if (e.keyCode === KeyCode.ENTER && props.onEnter) {
                props.onEnter();
            }
            if (props.onKeyDown) {
                props.onKeyDown(e);
            }
        };
        _this.onSelect = function (e) {
            if (_this.props.onSelect) {
                var t = e.target;
                var selection = calculateInputSelection(t);
                _this.props.onSelect(selection);
            }
        };
        return _this;
    }
    DeprecatedInput.prototype.componentDidMount = function () {
        if (this.props.validationError !== undefined) {
            deprecatedMsg('Usage of validationError prop in <DeprecatedInput/> is no longer valid');
        }
    };
    DeprecatedInput.prototype.render = function () {
        var disabledTooltipText = (typeof this.props.disabled === 'string') ? this.props.disabled : '';
        var props = __assign(__assign(__assign({}, defaultProps), this.props), { disabled: !!this.props.disabled });
        var invalid = !!props.validationError;
        var classNames = namespacedClassnames(deprecatedInputKey, props.className);
        var inputFieldClassNames = namespacedClassnames('input-field', { invalid: invalid });
        var tooltipRelativeToBody = props.tooltipRelativeToBody, restProps = __rest(props, ["tooltipRelativeToBody"]);
        var inputField = (React.createElement("input", __assign({}, restProps, { className: inputFieldClassNames, type: props.type || 'text', ref: this.setInputRef, onChange: this.onChange, onKeyDown: this.onKeyDown, onSelect: this.onSelect })));
        var renderInputField = function () {
            return disabledTooltipText ? (React.createElement(Tooltip, { body: disabledTooltipText, relativeToBody: props.tooltipRelativeToBody, direction: 'top' }, inputField)) : inputField;
        };
        return (React.createElement("span", { className: classNames },
            renderInputField(),
            invalid ? React.createElement("div", { className: 'validation-error' }, props.validationError) : null));
    };
    return DeprecatedInput;
}(React.PureComponent));
export { DeprecatedInput };
//# sourceMappingURL=input.js.map